import { render, staticRenderFns } from "./AttributesTable.vue?vue&type=template&id=15aa2efe&scoped=true"
import script from "./AttributesTable.vue?vue&type=script&lang=js"
export * from "./AttributesTable.vue?vue&type=script&lang=js"
import style0 from "./AttributesTable.vue?vue&type=style&index=0&id=15aa2efe&prod&scoped=true&lang=css"
import style1 from "./AttributesTable.vue?vue&type=style&index=1&id=15aa2efe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa2efe",
  null
  
)

export default component.exports